export const NFTPresale = "0x0B864d6508f2fd5F89B080f4453aDbf097c13Ec4";
export const SharbaeNFT = "0x2DeA27a12ee9B4EFF4B023dcf075983f5DfD908A";
// export const NFTPresale = "0xC4A9ddf8236a74b21C5ac19787545605D6555513";
// export const SharbaeNFT = "0x649E4C3E9D830A8a29F16c517999774B5ec31607";
